// extracted by mini-css-extract-plugin
export var pageTitle_decoration_1 = "download-page-title-module--pageTitle_decoration_1--2Gp62";